<div class="fv-row pull-right" [formGroup]="DateTimeForm">
  <div class="pb-1 pb-lg-4" dir="rtl">
    <h2 class="fw-bolder d-flex align-items-center text-dark">
      <span style="color:#c7e90d; margin: 6px 6px 10px 6px;" nz-icon nzType="calendar" nzTheme="outline"></span>
      أختر التاريخ :
    </h2>
  </div>
  <div class="mb-10 fv-row">
    <div style="display:flex;justify-content:end w-full">
      <nz-date-picker nzInline formControlName="date" style="width:100%; height: 47px;" [(ngModel)]="date1"
        (ngModelChange)="onChange($event)">
      </nz-date-picker>

    </div>

    <div class="row mt-4" data-kt-buttons="true" dir="rtl" *ngIf="displayTimeSection">
      <div class="col-md-12 mb-2" dir="rtl">
        <div class="pb-1 pb-lg-4 mt-7" dir="rtl">
          <h2 class="fw-bolder d-flex align-items-center text-dark">
            <span nz-icon style="color:#c7e90d; margin: 6px 6px 10px 6px;" nzType="clock-circle"
              nzTheme="outline"></span>
            أختر الوقت :
          </h2>

          <ul role="list" class="divide-y divide-gray-200 rounded-md border border-gray-200">
            <li class="flex items-center justify-between py-3 pl-3 pr-4 text-sm">
              <div class="flex w-0 flex-1 items-center">
                <span class="ml-2 w-0 flex-1 truncate">سعر الساعة الواحدة <span
                    style="color: #000;font-size: 14px !important;font-weight: bolder;" class="mx-2">
                    {{priceList.oneHourPrice}}
                  </span>ريال عماني</span>
              </div>
              <div class="ml-4 flex flex-shrink-0 space-x-4">
              </div>
            </li>
            <li class="flex items-center justify-between py-3 pl-3 pr-4 text-sm">
              <div class="flex w-0 flex-1 items-center">

                <span class="ml-2 w-0 flex-1 truncate">سعر الساعتين <span
                    style="color: #000;font-size: 14px !important;font-weight: bolder;" class="mx-2">
                    {{priceList.twoHourPrice}}
                  </span> ريال عماني</span>
              </div>
              <div class="ml-4 flex flex-shrink-0 space-x-4">

              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="mb-10 fv-row" dir="rtl">
      <div class="row mb-2" data-kt-buttons="true" dir="rtl" *ngIf="displayTimeSection">
  
        <div *ngIf="chooseagain" (click)="changeChoose()"
          style="text-decoration: underline;color: #0093ff;font-weight:500">تعديل الإختيار</div>

        <nz-spin [nzSpinning]="isLoadingTime">
      
          <div class="row mb-2">
            <div class="col-md-4 mb-2" dir="rtl" *ngFor="let item of paramsTest ; let i = index">
              <input type="checkbox" [disabled]="isDisabled" [(ngModel)]="item.isChecked" id="{{i}}" class="btn-check"
                [ngModelOptions]="{standalone: true}" value="{{item.time}}" (ngModelChange)="TimeSelected(item)">
              <label class=" btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4 flex-col" for="{{i}}"
                style="display: flex;gap: 5px;place-items: center;justify-content: center;direction: ltr;">
                <div class=" w-100  ">
                  <span class="fw-bolder fs-3" style="font-size: 14px !important;"> {{ tConvert(item.time)}} </span>
                  <span class="fw-bolder fs-3" style="font-size: 14px !important;"> - </span>
                  <span class="fw-bolder fs-3" style="font-size: 14px !important;"> {{ addHours(item.time)}} </span>
                </div>
    
                <span class="fw-bolder fs-3 font-muted" style="font-size: 12px !important;color:#888 ; font-weight: 300;"> {{item.date}} </span> 
                <br>
              </label>
    
    
            </div>
          </div>
        </nz-spin>
      </div>

 


      <div class="mt-2 text-danger" *ngIf="TimeList.length == 0">لا يوجد وقت متاح في هذا اليوم، الرجاء اختيار يوم آخر.
      </div>

      <!-- </div> -->

    </div>

    <div class="mb-10 fv-row" dir="rtl" *ngIf="isAppointmentsLisLoading">
      <img src="https://k.top4top.io/p_2493m5jfv1.gif" width="100px" style="margin: 0 auto" alt="">
    </div>


  </div>